export default __webpack_public_path__ + "static/media/KOL-CHELSEA OLIVIA.62530d0a.jpg";